import React from 'react'

function Contact() {
  return (
    <div className="legal-page">
        
            <h5>Last update on Aug 1 2025</h5>

            <p>You may contact us using the information below: </p>

            <p>
            Merchant Legal entity name : Mo Amir Khan
            Registered Address: Sai Heights, SN. 83/1 Sai Park Road, Dighi, Pune, Maharashtra – 411015
            <p>Phone No. 6392492293, 9559420174</p>
            email: contact@amfiaeducation.com
            </p>
        
    </div>
  )
}

export default Contact